import { render, staticRenderFns } from "./AssetDetails.vue?vue&type=template&id=59b8d40a&scoped=true&"
import script from "./AssetDetails.vue?vue&type=script&lang=ts&"
export * from "./AssetDetails.vue?vue&type=script&lang=ts&"
import style0 from "./AssetDetails.vue?vue&type=style&index=0&id=59b8d40a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b8d40a",
  null
  
)

export default component.exports